module.exports = {render: function () {with(this){return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M27.5 22l-3.3-5.5h6.7zm-8.5-.2H6v-19h13v19zm-12.1-.9H18v-17H6.9v17z"}}),_c('path',{attrs:{"d":"M11.8 15.9h5.8v4.3h-5.8zm0-5.7h5.8v4.3h-5.8zm0-5.8h5.8v4.3h-5.8z"}})])}}};


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg-icons/assign_bldgmodule.svg
// module id = 696
// module chunks = 2